/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomContractVariableValueDto } from './CustomContractVariableValueDto';
import {
    CustomContractVariableValueDtoFromJSON,
    CustomContractVariableValueDtoFromJSONTyped,
    CustomContractVariableValueDtoToJSON,
    CustomContractVariableValueDtoToJSONTyped,
} from './CustomContractVariableValueDto';

/**
 * 
 * @export
 * @interface CustomContractGuaranteeDto
 */
export interface CustomContractGuaranteeDto {
    /**
     * Unique identifier of the guarantee tunnel
     * @type {string}
     * @memberof CustomContractGuaranteeDto
     */
    guaranteeId: string;
    /**
     * 
     * @type {CustomContractVariableValueDto}
     * @memberof CustomContractGuaranteeDto
     */
    ceiling?: CustomContractVariableValueDto;
    /**
     * 
     * @type {CustomContractVariableValueDto}
     * @memberof CustomContractGuaranteeDto
     */
    deductible?: CustomContractVariableValueDto;
}

/**
 * Check if a given object implements the CustomContractGuaranteeDto interface.
 */
export function instanceOfCustomContractGuaranteeDto(value: object): value is CustomContractGuaranteeDto {
    if (!('guaranteeId' in value) || value['guaranteeId'] === undefined) return false;
    return true;
}

export function CustomContractGuaranteeDtoFromJSON(json: any): CustomContractGuaranteeDto {
    return CustomContractGuaranteeDtoFromJSONTyped(json, false);
}

export function CustomContractGuaranteeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomContractGuaranteeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'guaranteeId': json['guaranteeId'],
        'ceiling': json['ceiling'] == null ? undefined : CustomContractVariableValueDtoFromJSON(json['ceiling']),
        'deductible': json['deductible'] == null ? undefined : CustomContractVariableValueDtoFromJSON(json['deductible']),
    };
}

export function CustomContractGuaranteeDtoToJSON(json: any): CustomContractGuaranteeDto {
    return CustomContractGuaranteeDtoToJSONTyped(json, false);
}

export function CustomContractGuaranteeDtoToJSONTyped(value?: CustomContractGuaranteeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guaranteeId': value['guaranteeId'],
        'ceiling': CustomContractVariableValueDtoToJSON(value['ceiling']),
        'deductible': CustomContractVariableValueDtoToJSON(value['deductible']),
    };
}

